// const menuButton = document.querySelector('[aria-controls=siteMenu]');

// function toggleMenu() {
//   const expanded = menuButton.getAttribute('aria-expanded') !== 'true';
//   menuButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
//   document.body.classList[expanded ? 'add' : 'remove']('is-menu-open');
//   menuButton.firstElementChild.classList[expanded ? 'add' : 'remove'](
//     'is-active'
//   );
//   return expanded;
// }

// menuButton.addEventListener('click', toggleMenu);

// document.addEventListener('keydown', (e) => {
//   if (
//     menuButton.getAttribute('aria-expanded') === 'true' &&
//     e.key === 'Escape'
//   ) {
//     if (toggleMenu()) {
//       document.getElementById('siteMenu').focus();
//     } else {
//       menuButton.focus();
//     }
//   }
// });

/**
 * Get the width of the scrollbar
 */
function getScrollbarWidth() {
  // Create the measurement node
  const scrollDiv = document.createElement('div');
  const root = document.documentElement;

  scrollDiv.className = 'scrollbar-measure';
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Add it as a custom property
  root.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

  // Delete the DIV
  document.body.removeChild(scrollDiv);
}

export function getMenuElements() {
  const menuElements = {
    menuToggle: document.querySelector('.js-menu-toggle'),
    overlayMenu: document.querySelector('.js-overlay-menu'),
    body: document.querySelector('body'),
    menuClosers: document.querySelectorAll('.js-menu-close'),
  };

  return menuElements;
}

function closeOverlayMenu() {
  const { menuToggle, overlayMenu, body } = getMenuElements();

  body.classList.remove('overlay-menu-open');
  menuToggle.setAttribute('aria-expanded', 'false');
  overlayMenu.classList.remove('is-open');
  overlayMenu.classList.add('closed');
}

function openOverlayMenu() {
  const { menuToggle, overlayMenu, body } = getMenuElements();

  body.classList.add('overlay-menu-open');
  menuToggle.setAttribute('aria-expanded', 'true');
  overlayMenu.classList.add('is-open');
  overlayMenu.classList.remove('closed');
}

export function isOverlayMenuOpen() {
  const { body } = getMenuElements();
  const isOpen = body.classList.contains('overlay-menu-open');

  return isOpen;
}

function toggleOverlayMenu() {
  if (isOverlayMenuOpen()) {
    closeOverlayMenu();
  } else {
    openOverlayMenu();
  }
}

// Toggle button
function setupMenuButtons() {
  const { menuToggle, overlayMenu, menuClosers } = getMenuElements();

  if (overlayMenu && menuToggle) {
    menuToggle.addEventListener('click', toggleOverlayMenu);
  }

  // Close buttons
  if (overlayMenu && menuClosers) {
    for (let i = 0; i < menuClosers.length; i++) {
      menuClosers[i].addEventListener('click', closeOverlayMenu);
    }
  }

  // Esc key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOverlayMenuOpen()) {
      closeOverlayMenu();
    }
  });
}

// Header scroll
let ticking = false;
const headerHeightDifference = 47 * 2;

function checkHeaderScroll() {
  document.body.classList[scrollY > headerHeightDifference ? 'add' : 'remove'](
    'is-scrolled-past-header'
  );
  ticking = false;
}

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(checkHeaderScroll);
    ticking = true;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  getScrollbarWidth();

  setupMenuButtons();

  checkHeaderScroll();
});
